"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stop;

function stop() {
  var ts = this.TRANSITION_SCHEDULES;

  if (ts) {
    Object.keys(ts).forEach(function (s) {
      ts[s].timer.stop();
    });
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-move/core/transition/stop.js
 ** module id = 262
 ** module chunks = 0
 **/